import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { List } from 'linqts';
import {  NumbersByBetOption } from '../../lottoloca-commom/lottery-modex';

@Component({
  selector: 'app-numbers-by-bet',
  templateUrl: './numbers-by-bet.component.html',
  styleUrls: ['./numbers-by-bet.component.css'],
  providers: [
    
    { provide: MatFormFieldControl, useExisting: NumbersByBetComponent },
 
  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
 })
export class NumbersByBetComponent implements MatFormFieldControl<NumbersByBetOption[]>, ControlValueAccessor, OnInit {

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'numbers-by-bet';
  id = `numbers-by-bet-${NumbersByBetComponent.nextId++}`;
  describedBy = '';
  _isReady: boolean = false;
_items:UntypedFormArray;

  private onChange: (value: NumbersByBetOption[]) => void;
  private _value: NumbersByBetOption[] = [];


  constructor(@Optional() @Self() public ngControl: NgControl,
    fb: UntypedFormBuilder,
    private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>,
    private formBuilder: UntypedFormBuilder) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }



  public changeDate() {

    this.onChange(this.value);
  }

  writeValue(obj: NumbersByBetOption[]): void {

    this.value = obj;

    this.updateGui();
  }
  registerOnChange(onChange: (value: NumbersByBetOption[]) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): NumbersByBetOption[] | null {


    return this._value;

  }

  set value(value: NumbersByBetOption[] | null) {

    if (value == null) {
      this._value = [];
    }
    else {

      this._value = value;
    }

    this.updateGui();

    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input')!.focus();
    }
  }



  //******************************* */

  public _indexes: any[] = [];

  public updateGui(): any {

    let items:Array<UntypedFormGroup> = [];

    this.value.forEach(x=>
      {
        items.push(this.createItem(x.value,x.cost))
      });

    this.orderForm = this.formBuilder.group({
         items: this.formBuilder.array(items)
    });

    this._items = this.orderForm.get("items") as UntypedFormArray;

    this.orderForm.valueChanges
    .subscribe(()=>
    {
      this.propagateChanges();
    });
  }

  public showValue() {
 
  }

  public onChangeCoordinate(cost: number, value: any) {


  }

  public addNumbersByBetOption() {

    this.addItem();
  }

  public addItem(): void {

    let items = this.orderForm.get('items') as UntypedFormArray;

    items.push(this.createItem(0,0));

  }

  public propagateChanges() {
    
    let items = this.orderForm.get('items') as UntypedFormArray;

    this._value = items.value;

    if (this.onChange != null) {

       this.onChange(this.value)
    }
  }

  public showValues() {

  }

  public createItem(value:number,cost:number): UntypedFormGroup {


    return this.formBuilder.group({
      value:value,
      cost:cost
    });

  }

  orderForm: UntypedFormGroup;

  ngOnInit() {
    this.updateGui()
  }

  
  public remove(index:number) {

    this._items = this.orderForm.get("items") as UntypedFormArray;

    this._items.removeAt(index);

  }

}
